import { queryOptions } from "@tanstack/react-query";
import {
  getAppleHealthStatus,
  getIntegrationStatuses,
  getStravaActivities,
  getStravaStatus,
} from "api-client";

export function integrationStatusesQueryOptions() {
  return queryOptions({
    queryKey: ["integrations", "statuses"],
    queryFn: async () => {
      const response = await getIntegrationStatuses();
      return response.data.data;
    },
  });
}

export function appleHealthStatusQueryOptions() {
  return queryOptions({
    queryKey: ["integrations", "apple-health", "status"],
    queryFn: async () => {
      const response = await getAppleHealthStatus();
      return response.data.data;
    },
  });
}

export function stravaStatusQueryOptions() {
  return queryOptions({
    queryKey: ["integrations", "strava", "status"],
    queryFn: async () => {
      const response = await getStravaStatus();
      return response.data.data;
    },
  });
}

interface StravaActivitiesQueryOptions {
  limit: number;
  page: number;
}

export function stravaActivitiesQueryOptions(
  options: StravaActivitiesQueryOptions,
) {
  return queryOptions({
    queryKey: ["integrations", "strava", "activities", options],
    queryFn: async () => {
      const response = await getStravaActivities({
        query: { page: options.page, limit: options.limit },
      });
      return response.data.data;
    },
  });
}
